var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageFillPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 15.75C3.8375 15.75 3.48125 15.6063 3.18125 15.3188C2.89375 15.0188 2.75 14.6625 2.75 14.25V3.75C2.75 3.3375 2.89375 2.9875 3.18125 2.7C3.48125 2.4 3.8375 2.25 4.25 2.25H14.75C15.1625 2.25 15.5125 2.4 15.8 2.7C16.1 2.9875 16.25 3.3375 16.25 3.75V14.25C16.25 14.6625 16.1 15.0188 15.8 15.3188C15.5125 15.6063 15.1625 15.75 14.75 15.75H4.25ZM4.25 14.25H14.75V3.75H4.25V14.25ZM5 12.75H14L11.1875 9L8.9375 12L7.25 9.75L5 12.75ZM4.25 14.25V3.75V14.25Z",
    fill: "#7A5AF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageFillPrimary);
export default __webpack_public_path__ + "static/media/image-fill-primary.5080e283c07b43db4f187a453f299dca.svg";
export { ForwardRef as ReactComponent };